import { render, staticRenderFns } from "./ConferenceHeader.vue?vue&type=template&id=03d008a4&"
import script from "./ConferenceHeader.vue?vue&type=script&lang=js&"
export * from "./ConferenceHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports